export const BYTES_PER_KB = 1_024;

const MAX_UPLOAD_FILE_SIZE_MB = 50;

export const MB_SIZE = BYTES_PER_KB * BYTES_PER_KB;

export const MAX_UPLOAD_FILE_SIZE = MAX_UPLOAD_FILE_SIZE_MB * MB_SIZE; // 50MB

export const MAX_UPLOAD_COMPRESSED_FILE_SIZE_MB = 10; // 10MB
export const MAX_UPLOAD_COMPRESSED_FILE_SIZE = MAX_UPLOAD_COMPRESSED_FILE_SIZE_MB * MB_SIZE;

export const DOCUMENT_FILE_MIME_TYPE = {
  PDF: 'application/pdf',
  PNG: 'image/png',
  JPEG: 'image/jpeg',
  TEXT: 'text/plain',
};

export const IMAGE_FILE_MIME_TYPES = [DOCUMENT_FILE_MIME_TYPE.PNG, DOCUMENT_FILE_MIME_TYPE.JPEG];

// Types safe to render from a same-origin object URL. Documents are normalized to PDF
// on upload and /content pins application/pdf, so this is defence in depth against that
// ever loosening — an html or svg blob opened here would execute in this origin.
export const OPENABLE_MIME_TYPES = [
  DOCUMENT_FILE_MIME_TYPE.PDF,
  DOCUMENT_FILE_MIME_TYPE.PNG,
  DOCUMENT_FILE_MIME_TYPE.JPEG,
];

export const DOCUMENT_FILE_TYPE = {
  PDF: 'PDF',
  PNG: 'PNG',
  JPEG: 'JPEG',
};

export const FILE_NAME_CONTENT_DISPOSITION_PREFIX_REG_EX = /filename\*?=['"]?(?:UTF-\d['"]*)/i;

export const FILE_NAME_CONTENT_DISPOSITION_REG_EX = new RegExp(
  `${FILE_NAME_CONTENT_DISPOSITION_PREFIX_REG_EX.source}?([^;\r\n"']*)['"]?;?`,
  'g',
);
